import type { ReactNode } from "react";
import { Stack, Typography } from "@mui/material";

export type AdminListPageHeaderProps = {
  title: string;
  actions?: ReactNode;
};

export const AdminListPageHeader = ({
  title,
  actions,
}: AdminListPageHeaderProps) => (
  <Stack
    direction="row"
    sx={{
      justifyContent: "space-between",
      alignItems: "center",
      mb: 2,
      gap: 2,
      flexWrap: "wrap",
    }}
  >
    <Typography variant="h6">{title}</Typography>
    {actions && (
      // The actions wrap too: a sort dropdown + view toggle + primary button
      // is wider than a phone, and a rigid row pushes the button off-screen.
      <Stack
        direction="row"
        useFlexGap
        sx={{ alignItems: "center", flexWrap: "wrap", gap: 1 }}
      >
        {actions}
      </Stack>
    )}
  </Stack>
);
